import { Link } from 'react-router-dom';
import { Lock, CheckCircle } from 'lucide-react';

export default function ChallengeCard({
  challenge,
  topicId,
  index,
  isCompleted,
  isLocked = false,
}) {
  const content = (
    <div
      className={`
        relative p-4 rounded-xl border transition-all duration-200
        ${isLocked
          ? 'bg-game-surface/50 border-[#2a2d31]/50 opacity-60 cursor-not-allowed'
          : isCompleted
            ? 'bg-game-surface border-game-primary/30 hover:border-game-primary'
            : 'bg-game-surface border-[#2a2d31] hover:border-game-primary hover:shadow-lg hover:shadow-game-primary/10'
        }
      `}
    >
      {/* Challenge number */}
      <div className="flex items-center justify-between mb-2">
        <span className="text-xs font-medium text-game-text-dim">
          Challenge {index + 1}
        </span>
        {isCompleted && <CheckCircle size={16} className="text-game-primary" />}
        {isLocked && <Lock size={16} className="text-game-text-dim" />}
      </div>

      {/* Title */}
      <h3 className={`font-semibold ${isLocked ? 'text-game-text-dim' : 'text-game-text'}`}>
        {challenge.title}
      </h3>

      {/* Hover effect indicator */}
      {!isLocked && (
        <div className="absolute inset-0 rounded-xl bg-game-primary/5 opacity-0 hover:opacity-100 transition-opacity pointer-events-none" />
      )}
    </div>
  );

  if (isLocked) {
    return content;
  }

  return (
    <Link to={`/challenge/${topicId}/${challenge.id}`}>
      {content}
    </Link>
  );
}
